/**
 * Arrow keys / the pad on the book's HOME page (bookScreen.ts): which slip button or tile gets the focus next.
 * Pure: fed the on-screen boxes in reading order.
 */

export interface NavBox {
  left: number;
  top: number;
  width: number;
  height: number;
}

/**
 * ← → step through in reading order (round the end); ↑ ↓ go to the nearest box in the row above / below
 * (boxes whose middles are within a few pixels are one row), the one most nearly straight up / down. Stays
 * put at the top / bottom. Without layout (every box zero-sized) ↑ ↓ step like ← →.
 */
export function homeNav(boxes: readonly NavBox[], index: number, dir: 'up' | 'down' | 'left' | 'right'): number {
  const n = boxes.length;
  if (n < 2) return index;
  if (dir === 'left' || dir === 'right') return (index + (dir === 'left' ? -1 : 1) + n) % n;
  if (boxes.every((r) => r.width === 0)) return (index + (dir === 'up' ? -1 : 1) + n) % n;
  const cur = boxes[index]!;
  const cy = cur.top + cur.height / 2;
  const cx = cur.left + cur.width / 2;
  let best = -1;
  let bestDy = Infinity;
  let bestDx = Infinity;
  boxes.forEach((r, k) => {
    if (k === index) return;
    const dy = (r.top + r.height / 2 - cy) * (dir === 'up' ? -1 : 1);
    if (dy < 8) return;
    const dx = Math.abs(r.left + r.width / 2 - cx);
    if (dy < bestDy - 6 || (Math.abs(dy - bestDy) <= 6 && dx < bestDx)) {
      best = k;
      bestDy = dy;
      bestDx = dx;
    }
  });
  return best >= 0 ? best : index;
}
